module.exports = __webpack_public_path__ + "static/assets/b642bc962f488f800c054da650a62428.png";